module.exports = __webpack_public_path__ + "static/img/nodata.0627b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/PCimg/nodata.png
// module id = aBka
// module chunks = 41